<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p>Subject: Second Request for Verification  </p>
        <p>
            To Whom It May Concern:
        </p>
        <p class="letter-content">
            I recently submitted a request for investigation for the account(s) listed below. I submitted sufficient 
            information for you perform a reasonable investigation of my dispute. Unfortunately, you neglected to 
            conduct a reasonable investigation. If you had investigated properly you would have removed the 
            accounts.
        </p>
        <p class="letter-content">
            Depending solely on your flawed e-Oscar system has proven to produce less than accurate and fair 
            information. I request that you take a more active and accurate approach to re-investigate the following 
            accounts
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                Account Name: {{ creditor.furnisher_name }}
                <br/>
                <template v-if="creditor.reference_number">
                    Account Number: {{ creditor.reference_number }}<br/>
                </template>
                <template v-else>
                    Account Name: {{ creditor.account_number }}<br/>
                </template>

                <template v-if="creditor.reason">
                    <br />
                    Reason: {{ creditor.reason }}<br/>
                </template>
            </strong>
        </p>
        

        <p class="letter-content">
            As in Cushman v TransUnion, Stevenson v. TRW (Experian), and Richardson v. Fleet, Equifax, et al, the 
            courts ruled each and every time that the CRA couldn't merely "parrot" information from the creditors and 
            collection agencies...that they have to conduct an independent REASONABLE investigation to ensure the 
            validity of the debt and the honesty/integrity of the creditor/CA in question. Sending out a generic form 
            letter through the e-Oscar system that does not even contain my reasons for the dispute is by no ones 
            measure reasonable.
        </p>
        <p class="letter-content">
            As I'm sure you are aware, each violation of the Fair Credit Reporting Act allows damages of $1000 
            should this matter end up in court. If you fail to initiate an investigation regarding my dispute I will to 
            take legal action to protect my credit rating and myself. I will fully exercise my right under the Fair 
            Credit Reporting Act. 
        </p>
        <p>
            Kindly comply.
        </p>
        <p>
            Regards
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br>
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
            originalDisputeDate: {
                type: String
            },
            dateAccountRemoved: {
                type: String
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                moment:moment,
                address,
            };
        },
    };
</script>
